import getMessageForErrorKey from './getMessageForErrorKey'

// Normalizes API error payload (single key or array of keys) to a user-facing 
// message.
const apiErrorToErrorMessage = (apiError) => {
  const key = Array.isArray(apiError) ? apiError[0] : apiError
  return getMessageForErrorKey(key)
}

export default apiErrorToErrorMessage
